import {
  AssetCatalogApiClient,
  createAssetCatalogApiClient,
} from '@peritasai/data-access';
import type {
  AssetCatalogFilterParams,
  AssetCatalogItemDto,
  CreateAssetCatalogDto,
  UpdateAssetCatalogDto,
} from '@peritasai/types';
import { AssetCatalogItemEntity } from './asset-catalog.entity';

export interface AssetCatalogPage {
  assetCatalogItems: AssetCatalogItemEntity[];
  total: number;
  page: number;
  limit: number;
}

export interface IAssetCatalogRepository {
  getAssetCatalogPaginated(options: AssetCatalogFilterParams): Promise<AssetCatalogPage>;
  createAssetCatalogItem(dto: CreateAssetCatalogDto): Promise<AssetCatalogItemEntity>;
  updateAssetCatalogItem(id: string, dto: UpdateAssetCatalogDto): Promise<AssetCatalogItemEntity>;
  getAssetCatalogItem(id: string): Promise<AssetCatalogItemEntity>;
}

export class AssetCatalogRepository implements IAssetCatalogRepository {
  constructor(private readonly apiClient: AssetCatalogApiClient) {}
  
  async getAssetCatalogPaginated(
    options: AssetCatalogFilterParams = {}
  ): Promise<AssetCatalogPage> {
    const response = await this.apiClient.getAssetCatalog(options);
    return {
      assetCatalogItems: response.data.map((dto) => this.toEntity(dto)),
      total: response.total,
      page: response.page,
      limit: response.limit,
    };
  }

  async createAssetCatalogItem(dto: CreateAssetCatalogDto): Promise<AssetCatalogItemEntity> {
    const result = await this.apiClient.createAssetCatalogItem(dto);
    return this.toEntity(result);
  }

  async updateAssetCatalogItem(
    id: string,
    dto: UpdateAssetCatalogDto
  ): Promise<AssetCatalogItemEntity> {
    const result = await this.apiClient.updateAssetCatalogItem(id, dto);
    return this.toEntity(result);
  }

  async getAssetCatalogItem(id: string): Promise<AssetCatalogItemEntity> {
    const dto = await this.apiClient.getAssetCatalogItem(id);
    return this.toEntity(dto);
  }

  private toEntity(dto: AssetCatalogItemDto): AssetCatalogItemEntity {
    return new AssetCatalogItemEntity(dto);
  }
}

export const assetCatalogRepository = new AssetCatalogRepository(
  createAssetCatalogApiClient()
);
